{
  "login-secret-with-pin-page": {
    "buttons": {
      "resend": "Resend",
      "submit": "Submit"
    },
    "text": {
      "in-second": "in {{seconds}} s",
      "pin-email-invalid": "PIN is incorrect. Please check it in your Email and try again.",
      "pin-sms-invalid": "PIN is incorrect. Please check it in your SMS and try again.",
      "resend-pin-hint": "You did not receive any PIN?",
      "verify-email": "Verify your Email",
      "verify-phone-nr": "Verify your phone number",
      "verify-update": "Verify your update",
      "verify-update-by-email": "You will receive a confirmation pin by Email",
      "verify-update-by-sms": "You will receive a confirmation pin by SMS"
    }
  }
}
